import React, { useEffect, useRef, useState } from 'react';
import '@/assets/styles/invitation.less';
import imgUrl1 from '@/assets/images/invitation-bg1.gif';
import imgUrl2 from '@/assets/images/invitation-bg2.png';
import imgUrl3 from '@/assets/images/invitation-bg3.gif';

import conUrl1 from '@/assets/images/invitation-con1.gif';
import conUrl2 from '@/assets/images/invitation-con2.png';
import invitationleft from '@/assets/images/invitation-left.png';

import up from '@/assets/images/invitation-up.gif';
import audio from '@/assets/images/invitation-audio.png';


import SwipeableViews from 'react-swipeable-views';
import { virtualize } from 'react-swipeable-views-utils';
import { mod } from 'react-swipeable-views-core';

let music = require('@/assets/images/music.mp3');

//let isPlay: any = false;

const VirtualizeSwipeableViews: any = virtualize(SwipeableViews);

export default () => {
    const styles = {
        slideContainer: {
            height: '100vh',
            background: '#83d6cc'
        },
        slide: {
            height: '100vh',
            color: '#fff',
            overflow: 'hidden'
        },
        slide3: {
            height: 200,
            backgroundColor: '#6AC0FF',
        },
        pages_img: {
            height: '100%',
            maxWidth: 1920,
            background: 'no-repeat center center'
        },
        bgPic: {
            height: '100vh',
            width: '100%',
            overflow: 'hidden',
            backgroundSize: 'cover'
        },
        audioelement: {

        },
        paused: {
            position: 'fixed',
            right: 20,
            top: 40,
            height: 30.1875,
            width: 30.1875,
            background: 'data:image/png;base64,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'
        }
    };

    const autoplay: any = useRef('autoplay');
    const loop: any = useRef('loop');
    const audioRef: any = useRef();
    const[isPlay, setIsPlay] = useState(false);


    function testAutoPlay() {
        // 返回一个promise以告诉调用者检测结果
        return new Promise(resolve => {
            let audio = document.createElement('audio');
            // require一个本地文件，会变成base64格式
            audio.src = require('@/assets/images/music.mp3');
            document.body.appendChild(audio);
            // play返回的是一个promise
            audio.play().then(() => {
                audio.pause();
                // 支持自动播放
                audioRef.current.play();
                setIsPlay(true);
            }).catch(err => {
                // 不支持自动播放
                setIsPlay(false);
            }).finally(() => {
                audio.remove();
                // 告诉调用者结果
                resolve(autoplay);
            });
        });
    }

    useEffect(() => {
       testAutoPlay();
        //audioRef.current.play()
        document.addEventListener("WeixinJSBridgeReady", function () {//微信  
            audioRef.current.play();//音频播放
            setIsPlay(true);
        }, false);
    }, [])

    function slideRenderer(params: any) {
        const { index, key } = params;
        const case0Style:any = Object.assign({ position: 'relative' }, styles.slide);
        switch (mod(index, 2)) {
            case 0:
                return (
                    <div key={key} style={case0Style}>
                        <div style={Object.assign({ background: `url(${imgUrl1}) no-repeat center center` }, styles.bgPic)}>
                            <div style={Object.assign({ background: `url(${imgUrl2}) no-repeat center center` }, styles.bgPic)}>
                                <div style={Object.assign({ background: `url(${imgUrl3}) no-repeat center center` }, styles.bgPic)}>
                                    <div style={{
                                        background: `url(${up}) no-repeat top center`, width: '11.3vh', height: '13vh',
                                        overflow: 'hidden', backgroundSize: 'cover', margin: '87vh auto 0'
                                    }}>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 1:
                return (
                    <div key={key} style={Object.assign({ position: 'relative', background: '#83d6cc' }, styles.slide) as any}>
                        <div style={{
                            background: `url(${conUrl2}) no-repeat center center`, height: '100vh', width: '100%',
                            overflow: 'hidden', backgroundSize: 'cover', position: 'absolute', zIndex: 10
                        }}>
                            <div style={{
                                background: `url(${invitationleft}) no-repeat top center`, width: '7.1vh', height: '6.6vh',
                                overflow: 'hidden', backgroundSize: 'cover', position: 'absolute', top: '2.54vh', left: '2.54vh'
                            }}></div>
                        </div>
                        <div style={{
                            background: `url(${conUrl1}) no-repeat top center`, height: '25.9vh', width: '100%',
                            overflow: 'hidden', backgroundSize: 'cover', position: 'absolute', bottom: 0, right: 0,
                        }}>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }

    const playAudio = () => {
        if (isPlay) {
            setIsPlay(false);
            audioRef.current.pause();
        } else {
            setIsPlay(true);
            audioRef.current.play();
        }
    }

    return (
        <div>
            <VirtualizeSwipeableViews
                containerStyle={styles.slideContainer}
                axis="y"
                resistance
                slideRenderer={slideRenderer} />

            <div className='audioelement'>
                <audio ref={audioRef} loop={loop.current} src={music}></audio>
                <div style={{ position: 'fixed', right: '2vh', top: '2vh', height: 40, width: 40, background: `url(${audio}) no-repeat`, 
                backgroundSize: 'cover', border: 0, animation:isPlay? 'playing 1.5s linear infinite both':'' }} onClick={playAudio}></div>
            </div>
        </div>
    )
}